@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <div class="gallery-lightbox-container flex flex-around-stretch">
    <button
      [ngClass]="{ invisible: currentIndex === 0, mobile: breakpoints.ltMd }"
      (click)="prev()"
      aria-label="Previous"
      class="show-prev-btn"
      type="button"
    >
      <mat-icon class="rotate-90" svgIcon="arrow_down"></mat-icon>
    </button>
    <div #galleryLightbox class="gallery-lightbox flex-full">
      @for (item of galleryData.attachments | slice: 0 : limitTo; track item.Id; let i = $index) {
        @if (item.Type !== ATTACHMENT_TYPES.IMG_SECURED) {
          @if (currentIndex === i) {
            <gallery-lightbox-item [lightboxItem]="item"></gallery-lightbox-item>
          }
        }
        @if (item.Type === ATTACHMENT_TYPES.IMG_SECURED) {
          @if (currentIndex === i) {
            <gallery-lightbox-secure-item [lightboxItem]="item"></gallery-lightbox-secure-item>
          }
        }
      }
    </div>
    <button
      [ngClass]="{ invisible: hideNext, mobile: breakpoints.ltMd }"
      (click)="next()"
      aria-label="Next"
      class="show-next-btn"
      type="button"
    >
      <mat-icon class="rotate-270" svgIcon="arrow_down"></mat-icon>
    </button>
  </div>
  <button (click)="closeDialog()" class="close-btn" isIconButton="true" mat-button type="button">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
}
